import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '../lib/supabaseClient.ts';
import { UserDomain } from '../types/domains.ts';
import { getSession } from './useSession.ts';

// Function to fetch domain status
async function DomainStatusCheck(domain: string){
  const session = await getSession();


  const response = await fetch(`${import.meta.env.VITE_SUPABASE_URL}/functions/v1/add-domain/status`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${session.access_token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ domain }),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.error || `HTTP ${response.status}`);
  }
  return;
}

// Hook to manually check domain status and update database if needed
export function useDomainStatusCheck() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (userDomain: UserDomain) => {
      await DomainStatusCheck(userDomain.domain);
      return queryClient.invalidateQueries({ queryKey: ['user-domain'] });
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['domain-status'] }),
    onError: (_, userDomain) => {
      
        supabase
          .from('user_domains')
          .update({ status: 'misconfigured' })
          .eq('id', userDomain.id)
          .then(() => {
            queryClient.invalidateQueries({ queryKey: ['user-domain'] });
          });
    },
  });
}

export function useDomainStatus(domain?: string) {
  return useQuery({
    queryKey: ['domain-status'],
    queryFn: () => DomainStatusCheck(domain!),
    enabled: !!domain, // Only run if domain is provided
    staleTime: 1000 * 30, // 30 seconds
    retry: 2,
  });
}